import { createFileRoute } from '@tanstack/react-router'
import { ToolPage } from '../components/pages'
import { CatalogProvider } from '../content/catalog-context'
import { loadPageData } from '../content/page-data-fn'
import { ToolWidget } from '../components/tool-widget'

export const Route = createFileRoute('/de/tools/$toolSlug')({
  loader: ({ params }) =>
    loadPageData({ data: { kind: 'tool', locale: 'de', params } }),
  head: ({ loaderData }) => loaderData?.head ?? {},
  component: RouteComponent,
})

function RouteComponent() {
  const { toolSlug } = Route.useParams()
  return (
    <CatalogProvider snapshot={Route.useLoaderData().snapshot}>
      <ToolPage
        toolSlug={toolSlug}
        renderWidget={(tool) => <ToolWidget tool={tool} />}
      />
    </CatalogProvider>
  )
}
